export default __webpack_public_path__ + "static/media/payment_done.5257320d.svg";